
import axios from "./axiosinstance";

const LeadImportApi = {
  importExcel: (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return axios.post("leads/import-excel", formData);
  },
};

export default LeadImportApi;